<template>
<div>
    <Breadcrumbs main="HR" title="Employee Details" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-6">
                <div class="card-container">

                    <div class="card p-3 card-one-three">

                        <div>
                            <div class="d-flex justify-content-between">
                                <router-link :to="`/hr/organization/employee/edit/${this.$route.params.id}`">
                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit Details"></feather>
                                </router-link>
                                <div>
                                    <feather type="alert-octagon" size="20px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Emergency Details" v-b-modal.modal-prevent-closing-emergency></feather>
                                </div>
                            </div>

                            <div style="display:flex; flex-direction: column; align-items: center; justify-content: center;">
                                <img style="height: 100px; width: 100px; border-radius: 100%; object-fit: cover;" :src="show_image">
                            </div>

                            <div style="margin-top: 15px; display:flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
                                <h5>{{ this.temp_employee.first_name}} {{ this.temp_employee.last_name }}</h5>
                                <h7>{{ this.temp_employee.email}}</h7>
                            </div>

                            <div class="" style="display: flex; flex-direction: column; gap: 15px; margin:50px 0px">
                                <div class="d-flex" style="gap: 10px; align-items: center; padding:0px 30px">
                                    <div class="profileIcon">
                                        <b-icon icon="card-text" style="margin: 10px"></b-icon>
                                    </div>
                                    <div class="d-flex flex-row" style="gap: 10px;">
                                        <h7>Employee ID</h7>
                                        <h7 style="font-weight: 600;">{{ this.temp_employee.id }}</h7>
                                    </div>
                                </div>

                                <div class="display" style="padding:0px 30px">
                                    <div class="d-flex" style="gap: 10px; align-items: center;">
                                        <div class="profileIcon">
                                            <b-icon icon="telephone" style="margin: 10px"></b-icon>
                                        </div>
                                        <div class="d-flex flex-row" style="gap: 10px;">
                                            <h7>Phone No:</h7>
                                            <h7 style="font-weight: 600;">{{ this.temp_employee.phone_number }}</h7>
                                        </div>
                                    </div>

                                    <div class="d-flex" style="gap: 10px; align-items: center;">
                                        <div class="profileIcon">
                                            <b-icon icon="layout-text-sidebar" style="margin: 10px"></b-icon>
                                        </div>
                                        <div class="d-flex flex-row" style="gap: 10px;">
                                            <h7>Personal ID No:</h7>
                                            <h7 style="font-weight: 600;">{{ this.temp_employee.personal_id_no }}</h7>
                                        </div>
                                    </div>
                                </div>

                                <div class="display" style="padding:0px 30px">
                                    <div class="d-flex" style="gap: 10px; align-items: center;">
                                        <div class="profileIcon">
                                            <b-icon icon="calendar" style="margin: 10px"></b-icon>
                                        </div>
                                        <div class="d-flex flex-row" style="gap: 10px;">
                                            <h7>Date of Birth:</h7>
                                            <h7 style="font-weight: 600;">{{ this.temp_employee.date_of_birth }}</h7>
                                        </div>
                                    </div>
                                    <div class="d-flex" style="gap: 10px; align-items: center;">
                                        <div class="profileIcon">
                                            <b-icon icon="calendar2-date" style="margin: 10px"></b-icon>
                                        </div>
                                        <div class="d-flex flex-row" style="gap: 10px;">
                                            <h7>Joining Date:</h7>
                                            <h7 style="font-weight: 600;">{{ this.temp_employee.joining_date }}</h7>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex" style="gap: 10px; align-items: center; padding: 0px 30px">
                                    <div class="profileIcon">
                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier">
                                                <path d="M12 5.5L12.3536 5.14645C12.1583 4.95118 11.8417 4.95118 11.6464 5.14645L12 5.5ZM12 5.5C11.6464 5.14645 11.6464 5.14654 11.6462 5.14665C11.6462 5.14671 11.6461 5.14684 11.6459 5.14696C11.6457 5.1472 11.6454 5.14751 11.645 5.14789C11.6443 5.14864 11.6432 5.14967 11.6419 5.15097C11.6394 5.15357 11.6357 5.15725 11.631 5.162C11.6217 5.1715 11.6082 5.18527 11.5908 5.20316C11.556 5.23892 11.5058 5.29117 11.4424 5.35866C11.3155 5.49361 11.1354 5.68974 10.9198 5.93723C10.4892 6.43168 9.91451 7.13396 9.3389 7.96539C8.20317 9.6059 7 11.8387 7 14H8C8 12.1613 9.04683 10.1441 10.1611 8.53461C10.7105 7.74104 11.2608 7.06832 11.6739 6.59402C11.8802 6.35714 12.0517 6.17045 12.1709 6.04368C12.2305 5.98032 12.277 5.93197 12.3081 5.89987C12.3237 5.88382 12.3355 5.87183 12.3432 5.86406C12.347 5.86017 12.3498 5.85734 12.3515 5.85559C12.3524 5.85471 12.353 5.8541 12.3534 5.85376C12.3535 5.85359 12.3536 5.85349 12.3537 5.85345C12.3537 5.85343 12.3536 5.85346 12.3537 5.85345C12.3536 5.85349 12.3536 5.85355 12 5.5ZM17 14C17 11.8387 15.7968 9.6059 14.6611 7.96539C14.0855 7.13396 13.5108 6.43168 13.0802 5.93723C12.8646 5.68974 12.6845 5.49361 12.5576 5.35866C12.4942 5.29117 12.444 5.23892 12.4092 5.20316C12.3918 5.18527 12.3783 5.1715 12.369 5.162C12.3643 5.15725 12.3606 5.15357 12.3581 5.15097C12.3568 5.14967 12.3557 5.14864 12.355 5.14789C12.3546 5.14751 12.3543 5.1472 12.3541 5.14696C12.3539 5.14684 12.3538 5.14671 12.3538 5.14665C12.3536 5.14654 12.3536 5.14645 12 5.5C11.6464 5.85355 11.6464 5.85349 11.6463 5.85345C11.6464 5.85346 11.6463 5.85343 11.6463 5.85345C11.6464 5.85349 11.6465 5.85359 11.6466 5.85376C11.647 5.8541 11.6476 5.85471 11.6485 5.85559C11.6502 5.85734 11.653 5.86017 11.6568 5.86406C11.6645 5.87183 11.6763 5.88382 11.6919 5.89987C11.723 5.93197 11.7695 5.98032 11.8291 6.04368C11.9483 6.17045 12.1198 6.35714 12.3261 6.59402C12.7392 7.06832 13.2895 7.74104 13.8389 8.53461C14.9532 10.1441 16 12.1613 16 14H17ZM16 14C16 16.2091 14.2091 18 12 18V19C14.7614 19 17 16.7614 17 14H16ZM12 18C9.79086 18 8 16.2091 8 14H7C7 16.7614 9.23858 19 12 19V18Z" fill="#5d80f1"></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="d-flex flex-row" style="gap: 10px;">
                                        <h7>Blood Group:</h7>
                                        <h7 style="font-weight: 600;">{{this.temp_employee.blood_group }}</h7>
                                    </div>
                                </div>

                                <div class="d-flex" style="gap: 10px; align-items: center; padding:0px 30px">
                                    <div class="profileIcon">
                                        <b-icon icon="pin-map" style="margin: 10px"></b-icon>
                                    </div>
                                    <div class="d-flex flex-row" style="gap: 10px;">
                                        <h7>Address:</h7>
                                        <h7 style="font-weight: 600;">{{ this.temp_employee.address }}</h7>
                                    </div>
                                </div>
                                <div class="d-flex" style="gap: 10px; align-items: center; padding: 0px 30px; width: 100%;">
                                    <div style="display: flex; flex-direction: row; align-items: center; gap: 5px; width: 100%;">
                                        <div style="width: 25%;">
                                            <span>Location</span>
                                        </div>
                                        <div style="width: 75%;">
                                            <div style="display: grid; grid-template-columns: repeat(auto-fill, 100px); gap: 8px;">
                                                <div v-for="(loc, index) in temp_employee.location" :key="index" style="">
                                                    <h7 class="badge" style="font-size: small; width: 100px; text-align: center; background: #398D1F; color: #ffffff;" v-b-tooltip.hover :title="loc.name"> {{ loc.name.substring(0,15) }} </h7>
                                                </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <!-- <div class="d-flex" style="gap: 10px; align-items: center; padding:0px 30px">
                                    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px; margin-bottom: 4px;">
                                        <div style="width: 140px;">
                                            <span>Location</span>
                                        </div>
                                        <div class="d-flex flex-column flex-lg-row">
                                            <div v-for="(loc, index) in this.temp_employee.location" :key="index" style="">
                                                <span style="font-size: small; text-align: center; max-width: fit-content; margin-right: 4px; margin-bottom: 4px; background: #398D1F; color: #ffffff; " class="badge">{{ loc.name }}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div> -->

                            </div>

                        </div>

                    </div>

                </div>
            </div>
            <div class="col-xl-6">

                <div class="showcase2">
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Department</h6>

                                        <h4 class="mb-0 counter">{{ details.additional_info.department.name }}</h4>
                                        <button v-if="this.temp_employee.department == null" class="btn btn-primary" v-b-modal.modal-prevent-closing-edit>Add Department</button>
                                    </div>
                                    <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50px" height="50px">

                                        <g id="SVGRepo_iconCarrier">
                                            <title>group_fill</title>
                                            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g id="Development" transform="translate(-768.000000, -48.000000)" fill-rule="nonzero">
                                                    <g id="group_fill" transform="translate(768.000000, 48.000000)">
                                                        <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path>
                                                        <path d="M12,3 C10.3431,3 9,4.34315 9,6 C9,7.30622 9.83481,8.41746 11,8.82929 L11,11 L8,11 C6.34315,11 5,12.3431 5,14 L5,15.1707 C3.83481,15.5825 3,16.6938 3,18 C3,19.6569 4.34315,21 6,21 C7.65685,21 9,19.6569 9,18 C9,16.6938 8.16519,15.5825 7,15.1707 L7,14 C7,13.4477 7.44772,13 8,13 L16,13 C16.5523,13 17,13.4477 17,14 L17,15.1707 C15.8348,15.5825 15,16.6938 15,18 C15,19.6569 16.3431,21 18,21 C19.6569,21 21,19.6569 21,18 C21,16.6938 20.1652,15.5825 19,15.1707 L19,14 C19,12.3431 17.6569,11 16,11 L13,11 L13,8.82929 C14.1652,8.41746 15,7.30622 15,6 C15,4.34315 13.6569,3 12,3 Z" id="路径" fill="#09244B"> </path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </px-card>
                    </div>
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Designation</h6>
                                        <h4 class="mb-0 counter"> {{ details.additional_info.designation.title }}</h4>
                                        <button v-if="this.temp_employee.designation == null" class="btn btn-primary " v-b-modal.modal-prevent-closing-edit>Add Designation</button>
                                    </div>
                                    <svg fill="#000000" height="50px" width="50px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 480" xml:space="preserve">
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <g>
                                                    <g class="fill-info">
                                                        <path d="M399.67,60.827h-35.62V10c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v50.827H135.951V10c0-5.523-4.478-10-10-10 c-5.522,0-10,4.477-10,10v50.827H80.33c-5.522,0-10,4.477-10,10V470c0,5.523,4.478,10,10,10h319.34c5.523,0,10-4.477,10-10 V70.827C409.67,65.304,405.192,60.827,399.67,60.827z M90.33,460V80.827h299.34V460H90.33z"></path>
                                                        <path d="M354.05,383.967H141.157c-5.522,0-10,4.477-10,10s4.478,10,10,10H354.05c5.522,0,10-4.477,10-10 S359.572,383.967,354.05,383.967z"></path>
                                                        <path d="M308.43,414.38H186.777c-5.522,0-10,4.477-10,10s4.478,10,10,10H308.43c5.522,0,10-4.477,10-10 S313.952,414.38,308.43,414.38z"></path>
                                                        <path d="M323.636,358.347h30.413c5.522,0,10-4.477,10-10V116.446c0-5.523-4.478-10-10-10H125.951c-5.522,0-10,4.477-10,10 v231.901c0,5.523,4.478,10,10,10h30.412H323.636z M227.127,338.348h-60.764v-19.543c0-14.776,8.854-31.789,23.685-45.509 c8.739-8.086,18.628-14.227,28.459-17.917c0.796,0.204,1.626,0.324,2.485,0.324h6.135V338.348z M313.637,338.347h-66.51v-82.645 h11.881c0.161,0,0.318-0.017,0.478-0.024c10.022,3.776,20.218,9.902,29.131,17.773c15.666,13.832,25.02,30.787,25.02,45.353 V338.347z M344.05,126.445v211.902h-10.413v-19.543c0-34.153-30.871-66.784-63.918-80.538 c19.764-10.752,33.207-31.705,33.207-55.739c0-24.294-13.735-45.432-33.842-56.082H344.05z M282.926,182.528 c0,23.936-19.48,43.409-43.423,43.409c-23.932-0.001-43.401-19.474-43.401-43.409c0-23.946,19.47-43.427,43.401-43.427 C263.446,139.101,282.926,158.582,282.926,182.528z M146.362,338.348H135.95V126.446h0.001h73.98 c-20.1,10.65-33.83,31.787-33.83,56.082c0,23.733,13.113,44.451,32.466,55.319c-11.295,4.677-22.367,11.762-32.102,20.768 c-19.131,17.699-30.103,39.637-30.103,60.19V338.348z"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </px-card>
                    </div>
                </div>

                <div class="showcase">
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Asset</h6>

                                        <h4 class="mb-0 counter">{{ assetCount }}</h4>
                                    </div>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">

                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12H16C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10H8Z" class="fill-success"></path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V5C1 6.30622 1.83481 7.41746 3 7.82929V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V7.82929C22.1652 7.41746 23 6.30622 23 5V4ZM20 6H4C3.44772 6 3 5.55228 3 5V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V5C21 5.55228 20.5523 6 20 6ZM5 20V8H19V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20Z" fill="#0F0F0F"></path>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </px-card>
                    </div>
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Project</h6>

                                        <h4 class="mb-0 counter">{{ projectCount }}</h4>
                                    </div>
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                        <g id="SVGRepo_iconCarrier">
                                            <path fill-rule="evenodd" class="fill-danger" clip-rule="evenodd" d="M3.25 6C3.25 4.45831 4.48029 3.26447 6.00774 2.50075C7.58004 1.7146 9.69967 1.25 12 1.25C14.3003 1.25 16.42 1.7146 17.9923 2.50075C19.5197 3.26447 20.75 4.45831 20.75 6V18C20.75 19.5417 19.5197 20.7355 17.9923 21.4992C16.42 22.2854 14.3003 22.75 12 22.75C9.69967 22.75 7.58004 22.2854 6.00774 21.4992C4.48029 20.7355 3.25 19.5417 3.25 18V6ZM4.75 6C4.75 5.33255 5.31057 4.52639 6.67856 3.84239C8.00168 3.18083 9.88205 2.75 12 2.75C14.118 2.75 15.9983 3.18083 17.3214 3.84239C18.6894 4.52639 19.25 5.33255 19.25 6C19.25 6.66745 18.6894 7.47361 17.3214 8.15761C15.9983 8.81917 14.118 9.25 12 9.25C9.88205 9.25 8.00168 8.81917 6.67856 8.15761C5.31057 7.47361 4.75 6.66745 4.75 6ZM4.75 18C4.75 18.6674 5.31057 19.4736 6.67856 20.1576C8.00168 20.8192 9.88205 21.25 12 21.25C14.118 21.25 15.9983 20.8192 17.3214 20.1576C18.6894 19.4736 19.25 18.6674 19.25 18V14.7072C18.8733 15.0077 18.4459 15.2724 17.9923 15.4992C16.42 16.2854 14.3003 16.75 12 16.75C9.69967 16.75 7.58004 16.2854 6.00774 15.4992C5.55414 15.2724 5.12675 15.0077 4.75 14.7072V18ZM19.25 8.70722V12C19.25 12.6674 18.6894 13.4736 17.3214 14.1576C15.9983 14.8192 14.118 15.25 12 15.25C9.88205 15.25 8.00168 14.8192 6.67856 14.1576C5.31057 13.4736 4.75 12.6674 4.75 12V8.70722C5.12675 9.00772 5.55414 9.27245 6.00774 9.49925C7.58004 10.2854 9.69967 10.75 12 10.75C14.3003 10.75 16.42 10.2854 17.9923 9.49925C18.4459 9.27245 18.8733 9.00772 19.25 8.70722Z"></path>
                                        </g>
                                    </svg>

                                </div>
                            </div>
                        </px-card>
                    </div>
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Leave</h6>
                                        <h4 class="mb-0 counter">{{ leaveCount }}</h4>
                                    </div>
                                    <svg viewBox="0 0 48 48" version="1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 48 48" fill="#000000" width="30px" height="30px">

                                        <g id="SVGRepo_iconCarrier">
                                            <path fill="#FFCDD2" d="M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"></path>
                                            <path fill="#F44336" d="M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"></path>
                                            <g fill="#B71C1C">
                                                <circle cx="33" cy="10" r="3"></circle>
                                                <circle cx="15" cy="10" r="3"></circle>
                                            </g>
                                            <g fill="#BDBDBD">
                                                <path d="M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"></path>
                                                <path d="M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"></path>
                                            </g>
                                            <path fill="#F44336" d="M22.2,35.3c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5s0.3-0.3,0.5-0.3c0.2-0.1,0.5-0.1,0.7-0.1 s0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.6,0.3s0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.4-0.4,0.5 c-0.2,0.1-0.3,0.3-0.6,0.3S24.3,37,24,37s-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.3-0.3-0.4-0.5 C22.3,35.8,22.2,35.6,22.2,35.3z M25.3,31h-2.6l-0.4-11h3.3L25.3,31z"></path>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </px-card>
                    </div>

                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">Ticket</h6>

                                        <h4 class="mb-0 counter">{{ ticketCount }}</h4>
                                    </div>
                                    <svg height="30px" width="30px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">

                                        <g id="SVGRepo_iconCarrier">

                                            <g>
                                                <path class="st0 fill-success" d="M92.574,294.24V124.336H43.277C19.449,124.336,0,144.213,0,168.467v206.44 c0,24.254,19.449,44.133,43.277,44.133h62v45.469c0,3.041,1.824,5.777,4.559,6.932c2.736,1.154,5.957,0.486,8.023-1.641 l49.844-50.76h106.494c23.828,0,43.279-19.879,43.279-44.133v-0.061H172.262C128.314,374.846,92.574,338.676,92.574,294.24z"></path>
                                                <path class="st0 fill-danger" d="M462.717,40H172.26c-27.105,0-49.283,22.59-49.283,50.197v204.037c0,27.61,22.178,50.199,49.283,50.199 h164.668l75.348,76.033c2.399,2.442,6.004,3.172,9.135,1.852c3.133-1.322,5.176-4.434,5.176-7.887v-69.998h36.131 c27.106,0,49.283-22.59,49.283-50.199V90.197C512,62.59,489.822,40,462.717,40z M369.156,280.115H195.92v-24.316h173.236V280.115z M439.058,204.129H195.92v-24.314h243.138V204.129z M439.058,128.143H195.92v-24.315h243.138V128.143z"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </px-card>
                    </div>
                    <div class="">
                        <px-card class="static-top-widget-card">
                            <div slot="with-padding">
                                <div class="media static-top-widget">
                                    <div class="media-body">
                                        <h6 class="font-roboto mb-2">EOD</h6>

                                        <h4 class="mb-0 counter">{{ eodCount }}</h4>
                                    </div>
                                    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" height="30px" width="30px">

                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M8 10.25C8 9.83579 8.33579 9.5 8.75 9.5H18.75C19.1642 9.5 19.5 9.83579 19.5 10.25C19.5 10.6642 19.1642 11 18.75 11H8.75C8.33579 11 8 10.6642 8 10.25Z" fill="#212121"></path>
                                            <path d="M8 14.75C8 14.3358 8.33579 14 8.75 14H18.75C19.1642 14 19.5 14.3358 19.5 14.75C19.5 15.1642 19.1642 15.5 18.75 15.5H8.75C8.33579 15.5 8 15.1642 8 14.75Z" fill="#212121"></path>
                                            <path d="M8.75 18.5C8.33579 18.5 8 18.8358 8 19.25C8 19.6642 8.33579 20 8.75 20H13.25C13.6642 20 14 19.6642 14 19.25C14 18.8358 13.6642 18.5 13.25 18.5H8.75Z" fill="#212121"></path>
                                            <path d="M14 2C14.4142 2 14.75 2.33579 14.75 2.75V4H18.5V2.75C18.5 2.33579 18.8358 2 19.25 2C19.6642 2 20 2.33579 20 2.75V4H20.75C21.9926 4 23 5.00736 23 6.25V19.2459C23 19.4448 22.921 19.6356 22.7803 19.7762L17.2762 25.2803C17.1355 25.421 16.9447 25.5 16.7458 25.5H6.75C5.50736 25.5 4.5 24.4926 4.5 23.25V6.25C4.5 5.00736 5.50736 4 6.75 4H8V2.75C8 2.33579 8.33579 2 8.75 2C9.16421 2 9.5 2.33579 9.5 2.75V4H13.25V2.75C13.25 2.33579 13.5858 2 14 2ZM6 6.25V23.25C6 23.6642 6.33579 24 6.75 24H15.9958V20.7459C15.9958 19.5032 17.0032 18.4959 18.2458 18.4959H21.5V6.25C21.5 5.83579 21.1642 5.5 20.75 5.5H6.75C6.33579 5.5 6 5.83579 6 6.25ZM18.2458 19.9959C17.8316 19.9959 17.4958 20.3317 17.4958 20.7459V22.9394L20.4393 19.9959H18.2458Z" fill="#212121"></path>
                                        </g>
                                    </svg>

                                </div>
                            </div>
                        </px-card>
                    </div>

                </div>

            </div>
        </div>

        <!-- Tab view -->

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex; flex-direction: row; gap: 10px; cursor: pointer;">
                            <h6 @click="toggleItem('Operations')" :class="{ active: activeItem === 'Operations' }">Operations</h6>
                            <h6 @click="toggleItem('Assets')" :class="{ active: activeItem === 'Assets' }">Assets</h6>
                            <h6 @click="toggleItem('Supporting')" :class="{ active: activeItem === 'Supporting' }">Supporting Documents</h6>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="" v-if="activeItem === 'Supporting'">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card-container">

                                <div class="card p-3 card-one-three task-board-comments">

                                    <div class="d-flex justify-content-between ">
                                        <h6 class="my-2">Compliance</h6>

                                    </div>

                                    <b-table show-empty sticky-header :items="complianceFormByEmployee" :fields="tableCompliance" head-variant="light">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                        <template #cell(Submission)="data">

                                            <span v-if="data.item.submitted_by_current_user == false">

                                                <svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="30px" height="30px">

                                                    <g id="SVGRepo_iconCarrier">
                                                        <title>cross-circle</title>
                                                        <desc>Created with Sketch Beta.</desc>
                                                        <defs> </defs>
                                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                            <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-568.000000, -1087.000000)" class="fill-danger">
                                                                <path d="M584,1117 C576.268,1117 570,1110.73 570,1103 C570,1095.27 576.268,1089 584,1089 C591.732,1089 598,1095.27 598,1103 C598,1110.73 591.732,1117 584,1117 L584,1117 Z M584,1087 C575.163,1087 568,1094.16 568,1103 C568,1111.84 575.163,1119 584,1119 C592.837,1119 600,1111.84 600,1103 C600,1094.16 592.837,1087 584,1087 L584,1087 Z M589.717,1097.28 C589.323,1096.89 588.686,1096.89 588.292,1097.28 L583.994,1101.58 L579.758,1097.34 C579.367,1096.95 578.733,1096.95 578.344,1097.34 C577.953,1097.73 577.953,1098.37 578.344,1098.76 L582.58,1102.99 L578.314,1107.26 C577.921,1107.65 577.921,1108.29 578.314,1108.69 C578.708,1109.08 579.346,1109.08 579.74,1108.69 L584.006,1104.42 L588.242,1108.66 C588.633,1109.05 589.267,1109.05 589.657,1108.66 C590.048,1108.27 590.048,1107.63 589.657,1107.24 L585.42,1103.01 L589.717,1098.71 C590.11,1098.31 590.11,1097.68 589.717,1097.28 L589.717,1097.28 Z" id="cross-circle" sketch:type="MSShapeGroup"> </path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </span>
                                            <span v-else>
                                                <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">

                                                    <g id="SVGRepo_iconCarrier">
                                                        <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" class="fill-success"></path>
                                                        <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" class="fill-success"></path>
                                                    </g>
                                                </svg>

                                            </span>

                                        </template>

                                        <template #cell(onboarding)="data">
                                            <span v-if="data.item.onboarding_flow.title === 'Client'">
                                                <b-badge pill variant="primary">{{ data.item.onboarding_flow.title }}</b-badge>
                                            </span>
                                            <span v-if="data.item.onboarding_flow.title === 'Employee'">
                                                <b-badge pill variant="success">{{ data.item.onboarding_flow.title }}</b-badge>
                                            </span>

                                            <span v-if="data.item.onboarding_flow.title === 'Vendor'">
                                                <b-badge pill variant="info">{{ data.item.onboarding_flow.title }}</b-badge>
                                            </span>
                                        </template>

                                    </b-table>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card p-3 card-one-three task-board-comments">

                                <div class="d-flex justify-content-between ">
                                    <h6 class="my-2">Policy</h6>

                                </div>

                                <b-table show-empty sticky-header :items="policyFormByEmployeeList" :fields="tablePolicy" head-variant="light">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template #cell(Submission)="data">
                                        <span v-if="data.item.submitted_by_current_user == false">

                                            <svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="30px" height="30px">

                                                <g id="SVGRepo_iconCarrier">
                                                    <title>cross-circle</title>
                                                    <desc>Created with Sketch Beta.</desc>
                                                    <defs> </defs>
                                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                        <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-568.000000, -1087.000000)" class="fill-danger">
                                                            <path d="M584,1117 C576.268,1117 570,1110.73 570,1103 C570,1095.27 576.268,1089 584,1089 C591.732,1089 598,1095.27 598,1103 C598,1110.73 591.732,1117 584,1117 L584,1117 Z M584,1087 C575.163,1087 568,1094.16 568,1103 C568,1111.84 575.163,1119 584,1119 C592.837,1119 600,1111.84 600,1103 C600,1094.16 592.837,1087 584,1087 L584,1087 Z M589.717,1097.28 C589.323,1096.89 588.686,1096.89 588.292,1097.28 L583.994,1101.58 L579.758,1097.34 C579.367,1096.95 578.733,1096.95 578.344,1097.34 C577.953,1097.73 577.953,1098.37 578.344,1098.76 L582.58,1102.99 L578.314,1107.26 C577.921,1107.65 577.921,1108.29 578.314,1108.69 C578.708,1109.08 579.346,1109.08 579.74,1108.69 L584.006,1104.42 L588.242,1108.66 C588.633,1109.05 589.267,1109.05 589.657,1108.66 C590.048,1108.27 590.048,1107.63 589.657,1107.24 L585.42,1103.01 L589.717,1098.71 C590.11,1098.31 590.11,1097.68 589.717,1097.28 L589.717,1097.28 Z" id="cross-circle" sketch:type="MSShapeGroup"> </path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                        <span v-else>
                                            <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">

                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z" class="fill-success"></path>
                                                    <path d="M512 1024C229.376 1024 0 794.624 0 512S229.376 0 512 0s512 229.376 512 512-229.376 512-512 512zm0-983.04C253.952 40.96 40.96 253.952 40.96 512S253.952 983.04 512 983.04 983.04 770.048 983.04 512 770.048 40.96 512 40.96z" class="fill-success"></path>
                                                </g>
                                            </svg>

                                        </span>

                                    </template>

                                    <template #cell(onboarding)="data">
                                        <span v-if="data.item.onboarding_flow.title === 'Client'">
                                            <b-badge pill variant="primary">{{ data.item.onboarding_flow.title }}</b-badge>
                                        </span>
                                        <span v-if="data.item.onboarding_flow.title === 'Employee'">
                                            <b-badge pill variant="success">{{ data.item.onboarding_flow.title }}</b-badge>
                                        </span>

                                        <span v-if="data.item.onboarding_flow.title === 'Vendor'">
                                            <b-badge pill variant="info">{{ data.item.onboarding_flow.title }}</b-badge>
                                        </span>
                                    </template>

                                </b-table>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card p-3 card-one-three task-board-comments">
                                <h6 class="my-2">Supporting Documents</h6>

                                <b-table show-empty sticky-header :items="this.temp_employee.supporting_documents" :fields="Attachment" head-variant="light">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">
                                        <a :href="host+data.item.employee_attachment" target="_blank">{{ truncateText(data.item.attach_title, 100) }}</a>
                                    </template>
                                    <template #cell(action)="data">

                                        <div style="display: flex; flex-direction: row; gap:10px">
                                            <!-- <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather> -->
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="" v-if="activeItem === 'Assets'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-container">

                                <div class="card p-3 card-one-three task-board-comments">

                                    <div class="d-flex justify-content-between ">
                                        <h6 class="my-2">Asset Allocated</h6>
                                        <router-link to="/hr/asset-management/asset/list">
                                            <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Allocate Asset"> </feather>
                                        </router-link>

                                    </div>

                                    <b-table show-empty sticky-header :items="asset_list" :fields="tableAsset" head-variant="light">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>

                                        <template #cell(title)="data">

                                            <router-link :to="`/hr/asset-management/asset/details/${ data.item.asset.id}`"> {{ data.item.asset.name }}</router-link>
                                        </template>
                                        <template #cell(date)="data">
                                            <span class="badge badge-pill badge-secondary">{{ data.item.allocation_date }}</span>
                                        </template>

                                    </b-table>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="" v-if="activeItem=== 'Operations'">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card p-3 card-one-three task-board-comments">

                                <div class="d-flex justify-content-between ">
                                    <h6 class="my-2">Project Allocated</h6>
                                    <router-link to="/project/list">
                                        <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Assign to a Project"> </feather>
                                    </router-link>

                                </div>
                                <b-table show-empty sticky-header :items="project_list" :fields="tableProject" head-variant="light">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">

                                        <router-link :to="`/project/details/${data.item.id}`">{{ data.item.title }}</router-link>
                                    </template>
                                    <template #cell(date)="data">
                                        <span class="badge badge-pill badge-secondary">{{ data.item.deadline }}</span>
                                    </template>

                                </b-table>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card-container">

                                <div class="card p-3 card-one-three task-board-comments">
                                    <h6 class="my-2">Ticket</h6>

                                    <b-table show-empty sticky-header :items="ticket_list" :fields="tableTicket" head-variant="light">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>

                                        <template #cell(title)="data">
                                            {{ data.item.subject }}
                                        </template>
                                        <template #cell(ticket_priority)="data">
                                            <span v-if="data.item.priority == 'LOW'">
                                                <b-badge pill variant="info">{{ data.item.priority }}</b-badge>
                                            </span>
                                            <span v-if="data.item.priority == 'MEDIUM'">
                                                <b-badge pill variant="warning">{{ data.item.priority }}</b-badge>
                                            </span>
                                            <span v-if="data.item.priority == 'HIGH'">
                                                <b-badge pill variant="danger">{{ data.item.priority }}</b-badge>
                                            </span>
                                        </template>

                                    </b-table>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card p-3 card-one-three task-board-comments">

                                <h6 class="my-2">Leave</h6>

                                <b-table show-empty sticky-header :items="leave_list" :fields="tableLeave" head-variant="light">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <template #cell(title)="data">
                                        {{ data.item.reason }}
                                    </template>
                                    <template #cell(start_date)="data">
                                        <b-badge pill variant="success">{{ data.item.start_date }}</b-badge>
                                    </template>
                                    <template #cell(end_date)="data">
                                        <b-badge pill variant="danger">{{ data.item.end_date }}</b-badge>
                                    </template>

                                </b-table>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card-container">

                                <div class="card p-3 card-one-three task-board-comments">

                                    <div class="d-flex justify-content-between ">
                                        <h6 class="my-2">EOD</h6>

                                    </div>

                                    <b-table show-empty sticky-header :items="eod_list" :fields="tableEOD" head-variant="light">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>

                                        <template #cell(created_date)="data">

                                            <router-link :to="`/eod/details/${data.item.id}`"> {{ data.item.created_date }}</router-link>
                                        </template>

                                        <template #cell(status)="row">
                                            <span v-if="row.value == 'PENDING'">
                                                <b-badge pill variant="warning">{{ row.value }}</b-badge>
                                            </span>
                                            <span v-if="row.value == 'APPROVED'">
                                                <b-badge pill variant="success">{{ row.value }}</b-badge>
                                            </span>
                                            <span v-if="row.value == 'DISCUSSION'">
                                                <b-badge pill variant="primary">{{ row.value }}</b-badge>
                                            </span>

                                        </template>

                                        <template #cell(refer_to)="data">
                                            <span>
                                                <div v-if="data.item.reported_to !== null && data.item.reported_to.length > 0">
                                                    <div v-for="user in data.item.reported_to" :key="user.id">
                                                        <p>{{ user.first_name }}</p>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <p>--</p>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Department & Designation" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Department</label>
                        <select class="form-control digits" v-model="temp_employee.department">
                            <option v-for="(type, index) in department_list" :key="index" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Designation</label>
                        <select class="form-control digits" v-model="temp_employee.designation">
                            <option v-for="(type, index) in designation_list_by_department" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Emergency Detail Modal -->
    <b-modal id="modal-prevent-closing-emergency" ref="modal" title="Emergency Contact Information" hide-footer>
        <form ref="form">

            <div class="row">
                <div class="col-sm-6">
                    <b-form-group label="Relation" label-for="name-input">
                        <b-form-input v-model="temp_employee.emergency_contact.emergency_relation" placeholder="" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <b-form-group label="Name" label-for="name-input">
                        <b-form-input v-model="temp_employee.emergency_contact.emergency_name" placeholder="" disabled></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <b-form-group label="Phone" label-for="name-input">
                        <b-form-input v-model="temp_employee.emergency_contact.emergency_phone" placeholder="" disabled></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-6">
                    <b-form-group label="Email" label-for="name-input">
                        <b-form-input v-model="temp_employee.emergency_contact.emergency_email" placeholder="" disabled></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="Address" label-for="name-input">
                <b-form-textarea id="textarea-rows" placeholder="" rows="4" v-model="temp_employee.emergency_contact.emergency_address" disabled></b-form-textarea>
            </b-form-group>

        </form>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import {
    myHost
} from '../../../../_helpers/host'
export default {
    data() {
        return {

            activeItem: 'Operations',
            show_image: null,
            host: myHost.host,

            temp_employee: {
                id: '',
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                blood_group: '',
                joining_date: '',
                department: '',
                designation: '',
                address: '',
                personal_id_no: '',
                date_of_birth: '',
                photo: null,
                location:null,
                supporting_documents: null,
                emergency_contact: {
                    emergency_name: '',
                    emergency_phone: '',
                    emergency_address: '',
                    emergency_relation: '',
                    emergency_email: '',

                }


            },
            tableAsset: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Asset Name',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'Allocation Date',
                    sortable: true
                },

            ],
            tableProject: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Project Title',
                    sortable: true
                },
                {
                    key: 'date',
                    label: 'Deadline',
                    sortable: true
                },

            ],
            tableTicket: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Ticket Subject',
                    sortable: true
                },
                {
                    key: 'ticket_priority',
                    label: 'Priority',
                    sortable: true
                },

            ],
            tableLeave: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Reason',
                    sortable: true
                },
                {
                    key: 'start_date',
                    label: 'Start Date',
                    sortable: true
                },
                {
                    key: 'end_date',
                    label: 'End Date',
                    sortable: true
                },

            ],
            tableEOD: [{
                    key: 'index',
                    label: '#'
                },

                {
                    key: 'created_date',
                    label: 'EOD Date',
                    sortable: true
                },

                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },

                {
                    key: 'refer_to',
                    label: 'Reported to',
                    sortable: true
                },

            ],
            Attachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },

            ],
            tableCompliance: [{
                    key: 'index',
                    label: '#'
                },

                {
                    key: 'compliance.form_name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'onboarding',
                    label: 'Boarding Type',
                    sortable: true
                },
                {
                    key: 'Submission',
                    label: 'Submission',
                    class: 'text-center',
                    sortable: true
                },

            ],
            tablePolicy: [{
                    key: 'index',
                    label: '#'
                },

                {
                    key: 'policy.form_name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'onboarding',
                    label: 'Boarding Type',
                    sortable: true
                },
                {
                    key: 'Submission',
                    label: 'Submission',
                    class: 'text-center',
                    sortable: true
                },

            ],

        };
    },
    computed: {
        ...mapState({
            details: state => state.employee.employee_detail,
            department_list: state => state.department.departments,
            designation_list: state => state.designation.designation,

            asset_list: state => state.employee.employee_asset,
            assetCount: state => state.employee.employee_aseet_count,

            project_list: state => state.employee.employee_project,
            projectCount: state => state.employee.employee_project_count,

            ticket_list: state => state.employee.employee_ticket,
            ticketCount: state => state.employee.employee_ticket_count,

            leave_list: state => state.employee.employee_leave,
            leaveCount: state => state.employee.employee_leave_count,

            eod_list: state => state.employee.employee_eod,
            eodCount: state => state.employee.employee_eod_count,

            designation_list_by_department: state => state.designation.designation_by_department,

            complianceFormByEmployee: state => state.onBoarding.complianceFormByEmployee,
            policyFormByEmployeeList: state => state.onBoarding.policyFormByEmployee,

        }),

    },
    mounted() {
        this.$store.dispatch("employee/fetchEmployeeDetail", this.$route.params.id).then(() => {
            this.$store.dispatch("onBoarding/fetchComplianceFormByEmployee", this.details.user_object.id)
            this.$store.dispatch("onBoarding/fetchPolicyFormByEmployee", this.details.user_object.id)
        });
        this.$store.dispatch("employee/fetchEmployeeAsset", this.$route.params.id)
        this.$store.dispatch("employee/fetchEmployeeProject", this.$route.params.id)
        this.$store.dispatch("employee/fetchEmployeeTicket", this.$route.params.id)
        this.$store.dispatch("employee/fetchEmployeeLeave", this.$route.params.id)

        this.$store.dispatch("employee/fetchEmployeeEOD", this.$route.params.id)

        this.$store.dispatch("employee/fetchMyDetails")

        this.$store.dispatch("department/fetchDepartments")
        this.$store.dispatch("designation/fetchDesignations")

    },
    watch: {
        details(oldValue, newValue) {
            this.temp_employee.id = this.details.additional_info.employee_id
            this.temp_employee.first_name = this.details.user_object.first_name
            this.temp_employee.last_name = this.details.user_object.last_name
            this.temp_employee.email = this.details.user_object.email
            this.temp_employee.blood_group = this.details.additional_info.blood_group
            this.temp_employee.joining_date = this.details.additional_info.joining_date
            this.temp_employee.department = this.details.additional_info.department.id
            this.temp_employee.designation = this.details.additional_info.designation.id
            this.temp_employee.address = this.details.additional_info.address
            this.temp_employee.personal_id_no = this.details.additional_info.personal_id_no
            this.temp_employee.date_of_birth = this.details.additional_info.date_of_birth
            this.temp_employee.phone_number = this.details.additional_info.phone_number
            this.show_image = this.host + this.details.additional_info.photo
            this.temp_employee.supporting_documents = this.details.additional_info.supporting_documents
            this.temp_employee.location = this.details.additional_info.location ? this.details.additional_info.location : null
            // this.temp_employee.location = this.details.additional_info.location ? this.details.additional_info.location.map(loc => loc.id) : null
            this.temp_employee.emergency_contact.emergency_name = this.details.additional_info.emergency_contact.emergency_name?this.details.additional_info.emergency_contact.emergency_name : null
            this.temp_employee.emergency_contact.emergency_phone = this.details.additional_info.emergency_contact.emergency_phone?this.details.additional_info.emergency_contact.emergency_phone  : null
            this.temp_employee.emergency_contact.emergency_relation = this.details.additional_info.emergency_contact.emergency_relation?this.details.additional_info.emergency_contact.emergency_relation : null
            this.temp_employee.emergency_contact.emergency_address = this.details.additional_info.emergency_contact.emergency_address?this.details.additional_info.emergency_contact.emergency_address : null 
            this.temp_employee.emergency_contact.emergency_email = this.details.additional_info.emergency_contact.emergency_email?this.details.additional_info.emergency_contact.emergency_email : null




        },
        'temp_employee.department': function (newDepartmentId, oldDepartmentId) {

            if (newDepartmentId) {
                this.$store.dispatch("designation/fetchDesignationsbyDepartment", newDepartmentId);
            }
        }
    },
    methods: {
        toggleItem(item) {
            this.activeItem = item;
        },
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.temp_employee.location = this.details.additional_info.location ? this.details.additional_info.location.map(loc => loc.id) : null
            this.$store.dispatch("employee/updateEmployee", {
                id: this.$route.params.id,
                info: this.temp_employee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.temp_employee.blood_group = '',
                        this.temp_employee.joining_date = null,
                        this.temp_employee.department = '',
                        this.temp_employee.designation = '',
                        this.temp_employee.address = '',
                        this.temp_employee.personal_id_no = '',
                        this.temp_employee.date_of_birth = null,
                        this.temp_employee.photo = null

                    this.$nextTick(() => {
                        this.$bvModal.hide('modal-prevent-closing-edit')
                    })

                    // setTimeout(() => {
                    //     this.$router.push('/hr/organization/employee')
                    // }, 3000)

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
    }
}
</script>

<style scoped>
.active {
    color: #ff595d;
}

.profileIcon {
    color: #5d80f1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #7794f32f;
    border-radius: 9999px;
    height: 35px;
    width: 35px;
}

.socialIcon {
    color: #5d80f1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #7794f32f;
    border-radius: 9999px;
    height: 40px;
    width: 40px;
    font-size: larger;
}

.task-board-comments {
    max-height: 350px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.display {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between
}

.showcase {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: auto;
    gap: 10px;
}

.showcase2 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto;
    gap: 20px;
}

@media (min-width: 1200px) and (max-width: 1500px) {
    .showcase2 {
        display: grid;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        grid-template-rows: auto;
        gap: 5px;
    }
}

@media (min-width: 1200px) and (max-width: 1500px) {
    .showcase {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-rows: auto;
        gap: 10px;
    }
}

@media only screen and (max-width: 660px) {
    .display {
        display: flex;
        flex-direction: column;
        justify-content: space-between
    }

}

@media (min-width: 1200px) and (max-width: 1500px) {
    .display {
        display: flex;
        flex-direction: column;
        justify-content: space-between
    }
}
</style>
